import { render, staticRenderFns } from "./DefaultFooter.vue?vue&type=template&id=3f1d432b&scoped=true"
import script from "./DefaultFooter.vue?vue&type=script&lang=ts"
export * from "./DefaultFooter.vue?vue&type=script&lang=ts"
import style0 from "./DefaultFooter.vue?vue&type=style&index=0&id=3f1d432b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1d432b",
  null
  
)

export default component.exports